import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  whichCostFactor: null,
  whichStep: 'review', // review / generate
  additionalData: '',
  isGenerationModelLoader: false,
  selectedVersionBreakdown: null,
}
const genAiTopDownFlowSlice = createSlice({
  name: 'genAiTopDownFlow',
  initialState: initialState,
  reducers: {
    setGenAiTopDownFlowData(state, action) {
      return { ...state, ...action.payload }
    },
    setWhichCostFactor(state, action) {
      state.whichCostFactor = action.payload
    },
    setWhichStep(state, action) {
      state.whichStep = action.payload
    },
    setAdditionalInput(state, action) {
      state.additionalData = action.payload
    },
    setSelectedVersionBreakdown(state, action) {
      state.selectedVersionBreakdown = action.payload
    },
    resetGenAiState: () => initialState,
  },
})

export const {
  setGenAiTopDownFlowData,
  setWhichCostFactor,
  setWhichStep,
  setAdditionalInput,
  resetGenAiState,
  setSelectedVersionBreakdown
} = genAiTopDownFlowSlice.actions
export default genAiTopDownFlowSlice.reducer
